import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP src/lib/agents/capability-inference.ts +
// src/lib/missions/capabilities.ts. See metadata.md for the file:line map.
//
// FRAMING: the email idea was "LLM-Enhanced Agent Capability Inference". The code
// is keyword-deterministic FIRST; the LLM is a bounded, guarded tie-breaker that
// only runs on medium-confidence non-canonical intents. The script follows the
// code: keyword matcher is the star, the LLM fallback is named honestly.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 6, caption: "I map a user's free-form request to the right agent skills. The obvious tool was an LLM. I shipped a keyword matcher instead — on purpose." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "An LLM call sits on the hot path of EVERY request — tokens, latency, and a different answer each time." },
  { scene: "problem", fromSec: 6, holdSec: 6.5, caption: "The header says it plainly: burning 4-5 LLM turns to discover what the keywords already say wastes tokens and irritates the user." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "'Send me a daily code-smell email' isn't ambiguous — it names an outcome, a channel, and a cadence." },
  { scene: "intuition", fromSec: 6, holdSec: 6.5, caption: "The words ARE the signal. A substring matcher reads them deterministically — no model required." },
];

export const APPROACH: ScriptLine[] = [
  { scene: "approach", fromSec: 0.4, holdSec: 5.5, caption: "Lowercase the intent, test it against keyword rules, and collect the canonical capability slugs that fire." },
  { scene: "approach", fromSec: 6, holdSec: 6.5, caption: "Match count buckets confidence: 3+ slugs is high, 1-2 medium, 0 low. Same input, same output, always." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6, caption: "Each rule is a capability plus broad substrings. 'email', 'send', 'notify', 'digest' all imply gmail_send." },
  { scene: "code", fromSec: 6.5, holdSec: 6.5, caption: "'code', 'audit', 'docs', 'recent' imply reading the knowledge base. ANY hit wins the rule." },
  { scene: "code", fromSec: 13, holdSec: 7, caption: "Confidence is just the match count. Pure function — no I/O, no clock, no network. Unit-testable, snapshot-stable." },
];

export const TIEBREAK: ScriptLine[] = [
  { scene: "tiebreak", fromSec: 0.4, holdSec: 6, caption: "Honest caveat: there IS one LLM call. It fires ONLY when confidence is exactly medium and the intent isn't a canonical pattern." },
  { scene: "tiebreak", fromSec: 6.5, holdSec: 6.5, caption: "max_tokens 200, it can only ADD missed capabilities, never override the matcher, and any failure degrades silently to the keyword result." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "The auto-planner's main entry runs the matcher with NO LLM — high confidence skips the multi-turn interview entirely." },
  { scene: "payoff", fromSec: 6, holdSec: 6.5, caption: "The failure mode is just 'we asked one extra question' — the system's status quo. The blast radius is tiny." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Reach for an LLM when the input is genuinely fuzzy. When the words already carry the intent, a matcher is faster, cheaper, and testable." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: my RAG was quietly burning money on every query — the cost-aware layer that fixed it." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
